exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CenteredMapMarker_root_uDzpM {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-left: -56px;\n  margin-top: -64px;\n  overflow: visible;\n  pointer-events: none;\n}\n", ""]);

// exports
exports.locals = {
	"root": "CenteredMapMarker_root_uDzpM"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader!./src/ondemand/components/CenteredMapMarker/CenteredMapMarker.css
// module id = 1362
// module chunks = 1